import {
  BadgeCheck,
  ReceiptText,
  KeyRound,
  CircleCheckBig,
  MessageCircle,
} from "lucide-react";
import { trust } from "../content/site";
import { Container, Reveal, Stagger, StaggerItem } from "./ui";

// One icon per trust.points entry, by position — keep the two lists in step.
const ICONS = [BadgeCheck, ReceiptText, KeyRound, CircleCheckBig, MessageCircle];

export default function TrustSection() {
  return (
    <section className="relative overflow-hidden bg-navy py-20 sm:py-28">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-0 right-0 h-96 w-96 rounded-full bg-primary/10 blur-[120px]" />
        <div className="absolute bottom-0 left-0 h-96 w-96 rounded-full bg-secondary/10 blur-[120px]" />
      </div>

      <Container className="relative">
        <Reveal className="mx-auto max-w-2xl text-center">
          <h2 className="text-3xl leading-[1.1] font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
            {trust.headline}
          </h2>
        </Reveal>

        <Stagger className="mx-auto mt-14 grid max-w-4xl grid-cols-2 gap-4 sm:grid-cols-3">
          {trust.points.map((point, idx) => {
            const Icon = ICONS[idx];
            return (
              <StaggerItem key={point}>
                <div className="flex h-full flex-col items-center gap-3 rounded-2xl border border-white/10 bg-white/5 p-6 text-center backdrop-blur-sm transition-colors hover:border-primary/30 hover:bg-white/[0.08]">
                  <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary/15 text-primary">
                    <Icon size={20} />
                  </span>
                  <span className="text-sm font-bold text-white/90">{point}</span>
                </div>
              </StaggerItem>
            );
          })}
        </Stagger>
      </Container>
    </section>
  );
}
